<template>
  <v-container
    id="roboPesquisaForm"
    fluid
    tag="section"
  >
    <base-material-card       
      color="primary"
      icon="mdi-robot-outline"
      :title="$t('roboPesquisa')">
      <v-form>
        <v-btn
        class="mr-4"
        color="default"
        @click="doCarregaForm">
        Busca
        </v-btn> 
        <v-btn
        class="mr-4"
        color="success"
        @click="doNovoCadastro">
        Novo
        </v-btn>             
        <v-container class="py-0">
          <v-simple-table fixed-header>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Nome
                  </th>
                  <th class="text-left">
                    Descrição
                  </th>
                  <th class="text-left">
                    Ativo
                  </th>
                  <th class="text-left">
                    UniqueId
                  </th>
                  <th class="text-left" >
                  </th>                  
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in listaDados"
                  :key="item.id"
                >
                  <td>{{ item.nome }}</td>
                  <td>{{ item.descricao }}</td>
                  <td>{{ item.ativo }}</td>
                  <td>{{ item.uniqueId }}</td>
                  <td>  <v-icon
                    small
                    class="mr-2"
                    @click="doEditaCadastro(item)"
                  >
                    mdi-pencil
                  </v-icon> </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <roboCadastroForm
            :exibedialog="dialog"
            :objeto="itemSelecionado"
            @update-dialog="updateDialog"
          />

        </v-container>
      </v-form>
    </base-material-card>
  </v-container>
</template>

<script>

  import { mask } from 'vue-the-mask'
  import roboCadastroForm from "../forms/RoboCadastroForm"
  import service from '../../../services/roboservice'
  
  export default {
    name: 'roboPesquisaForm',
    components: {
      roboCadastroForm,
    },
    directives: {
      mask,
    },
    data: () => ({
      listaDados: [{
        id: -1,
        nome: '',
        
      }],
      itemSelecionado: {

      },
      nomeErro: false,
      erros: [],
      dialog: false,
    }),
    mounted () {
      this.doCarregaForm()
    },
    methods: {
      doCarregaForm () {
        this.listaDados = []
        service.listar().then(resposta => {
          this.listaDados = resposta.data.list
        }).catch(e => {
          if (e.message === 'Network Error') {
            console.log('Network Error: ' + e.response)
          } else {
            console.log('Erro listar(): ')
            console.log( e)                      
          }
        })
      },
      doValidate () {
        this.erros = []
     
        if (this.erros.length === 0) {
          return true
        }   
      },
      doEditaCadastro (item) {                
        this.itemSelecionado = item
        this.dialog = true
      },
      doNovoCadastro () {
        this.dialog = true
      },
      updateDialog (dialog) {
        this.dialog = dialog
        this.doCarregaForm()
      },

      doFormataData(data){
        if(!data)
          return null
        return gettanggal(data)
      },
    },
  }
</script>
